var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "seller-style": _vm.isSeller == 1 } },
    [
      _vm.isSeller == 0
        ? _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              attrs: {
                "label-suffix": "：",
                model: _vm.searchForm,
                "label-position": "left",
                inline: "",
                "label-width": "110px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex pad5-t row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { size: "medium", label: "按日期筛选" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["00:00:00", "23:59:59"],
                          "value-format": "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.searchForm.orderTimeInterval,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "orderTimeInterval", $$v)
                          },
                          expression: "searchForm.orderTimeInterval"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: { label: "按订单号查询", "label-width": "110px" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入订单编号"
                        },
                        model: {
                          value: _vm.searchForm.orderId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "orderId", $$v)
                          },
                          expression: "searchForm.orderId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { size: "medium", label: "按货品查询" } },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入货品关键词"
                        },
                        model: {
                          value: _vm.searchForm.goodsName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "goodsName", $$v)
                          },
                          expression: "searchForm.goodsName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: { label: "按店铺查询", "label-width": "110px" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入店铺名称"
                        },
                        model: {
                          value: _vm.searchForm.shopName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "shopName", $$v)
                          },
                          expression: "searchForm.shopName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w260",
                          attrs: {
                            "popper-class": "theme-blue",
                            placeholder: "请选择订单类型",
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.orderDtlType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "orderDtlType", $$v)
                            },
                            expression: "searchForm.orderDtlType"
                          }
                        },
                        _vm._l(_vm.orderTypeList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.text, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: { size: "medium", label: "下单人查询" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入下单人姓名"
                        },
                        model: {
                          value: _vm.searchForm.nextSingleName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "nextSingleName", $$v)
                          },
                          expression: "searchForm.nextSingleName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人查询", "label-width": "110px" } },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入收货人姓名"
                        },
                        model: {
                          value: _vm.searchForm.receiverName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "receiverName", $$v)
                          },
                          expression: "searchForm.receiverName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "flex justify-end submit",
                      staticStyle: { "margin-left": "30px" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "self-start",
                          attrs: { size: "medium", type: "primary" },
                          on: { click: _vm.submitOrderList }
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "resize self-start",
                          attrs: { size: "medium" },
                          on: { click: _vm.resetOrderList }
                        },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.isSeller == 1
        ? _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form seller-style",
              attrs: {
                "label-suffix": "：",
                model: _vm.searchForm,
                "label-position": "left",
                inline: "",
                "label-width": "110px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex pad5-t row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { size: "medium", label: "按日期筛选" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["00:00:00", "23:59:59"],
                          "popper-class": "theme-blue",
                          "value-format": "yyyy-MM-dd HH:mm:ss"
                        },
                        model: {
                          value: _vm.searchForm.orderTimeInterval,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "orderTimeInterval", $$v)
                          },
                          expression: "searchForm.orderTimeInterval"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: { label: "按订单号查询", "label-width": "150px" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入订单编号"
                        },
                        model: {
                          value: _vm.searchForm.orderId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "orderId", $$v)
                          },
                          expression: "searchForm.orderId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { size: "medium", label: "按姓名查询" } },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入买家/收货人/自提人姓名"
                        },
                        model: {
                          value: _vm.searchForm.nextSingleName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "nextSingleName", $$v)
                          },
                          expression: "searchForm.nextSingleName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: {
                        size: "medium",
                        label: "按货品查询",
                        "label-width": "150px"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "w260",
                        attrs: {
                          size: "medium",
                          placeholder: "请输入货品关键词"
                        },
                        model: {
                          value: _vm.searchForm.goodsName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "goodsName", $$v)
                          },
                          expression: "searchForm.goodsName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w260",
                          attrs: {
                            "popper-class": "theme-blue",
                            placeholder: "请选择订单类型",
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.orderDtlType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "orderDtlType", $$v)
                            },
                            expression: "searchForm.orderDtlType"
                          }
                        },
                        _vm._l(_vm.orderTypeList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.text, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: {
                        size: "medium",
                        label: "配送方式",
                        "label-width": "150px"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w260",
                          attrs: {
                            "popper-class": "theme-blue",
                            placeholder: "请选择配送方式",
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.delivery,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "delivery", $$v)
                            },
                            expression: "searchForm.delivery"
                          }
                        },
                        _vm._l(_vm.deliveryList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.text, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否开具发票" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w260",
                          attrs: {
                            "popper-class": "theme-blue",
                            placeholder: "请选择",
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.isReceipt,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "isReceipt", $$v)
                            },
                            expression: "searchForm.isReceipt"
                          }
                        },
                        [
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                          _c("el-option", { attrs: { label: "否", value: 0 } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mar30-l",
                      attrs: {
                        label: "确认提货/发货时间",
                        "label-width": "150px"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w260",
                          attrs: {
                            "popper-class": "theme-blue",
                            placeholder: "请选择",
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.confirmStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "confirmStatus", $$v)
                            },
                            expression: "searchForm.confirmStatus"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已确认", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "未确认", value: 0 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex row" },
                [
                  _vm.searchForm.delivery == 2
                    ? _c(
                        "el-form-item",
                        { attrs: { size: "medium", label: "是否确认自提" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w260",
                              attrs: {
                                "popper-class": "theme-blue",
                                placeholder: "请选择确认自提状态",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.orderVehicleStatus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "orderVehicleStatus",
                                    $$v
                                  )
                                },
                                expression: "searchForm.orderVehicleStatus"
                              }
                            },
                            _vm._l(_vm.orderVehicleStatusList, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.text, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      class: { "mar30-l": _vm.searchForm.delivery == 2 },
                      attrs: { size: "medium", "label-width": "110px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex justify-end mar15-b" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "self-start",
                              attrs: { size: "medium", type: "primary" },
                              on: { click: _vm.submitOrderList }
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "resize self-start",
                              attrs: { size: "medium" },
                              on: { click: _vm.resetOrderList }
                            },
                            [_vm._v("重置")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "resize self-start",
                              attrs: { size: "medium", type: "primary" },
                              on: { click: _vm.exportOrderList }
                            },
                            [_vm._v("导出")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          class: { "theme-blue": _vm.isSeller == 1 },
          staticStyle: { "min-height": "500px" }
        },
        [
          _c(
            "table",
            { staticClass: "table-list", staticStyle: { width: "99%" } },
            [
              _vm.isSeller == 0
                ? _c("thead", { staticClass: "text-center f14 gray3" }, [
                    _c("th", { attrs: { width: "34%" } }, [_vm._v("货品")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("数量")]),
                    _c("th", { attrs: { width: "15%" } }, [_vm._v("价格")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("收货人")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("合计金额")]),
                    _c("th", { attrs: { width: "8%" } }, [_vm._v("订单状态")]),
                    _c("th", [_vm._v("操作")])
                  ])
                : _vm._e(),
              _vm.isSeller == 1
                ? _c("thead", { staticClass: "text-center f14 gray3" }, [
                    _c("th", { attrs: { width: "45%" } }, [_vm._v("货品")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("数量")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("价格")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("合计金额")]),
                    _c("th", { attrs: { width: "10%" } }, [_vm._v("订单状态")]),
                    _c("th", [_vm._v("操作")])
                  ])
                : _vm._e(),
              _vm.list && _vm.list.length
                ? _vm._l(_vm.list, function(order, index) {
                    return _c(
                      "tbody",
                      { key: index, staticClass: "text-center border-b" },
                      [
                        _vm.isSeller == 1
                          ? [
                              _vm._m(0, true),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-left gray6 des",
                                    attrs: { colspan: "6" }
                                  },
                                  [
                                    _c("div", { staticClass: "flex" }, [
                                      _c("div", { staticClass: "w220" }, [
                                        _vm._v(
                                          "下单时间：" + _vm._s(order.orderTime)
                                        )
                                      ]),
                                      _c("div", { staticClass: "w220" }, [
                                        _vm._v(
                                          "订单编号：" + _vm._s(order.orderId)
                                        )
                                      ]),
                                      _c("div", { staticClass: "w182" }, [
                                        _vm._v(
                                          "收货人：" + _vm._s(order.linkman)
                                        )
                                      ]),
                                      _c("div", { staticClass: "mar5-lr" }, [
                                        _vm._v(
                                          _vm._s(
                                            order.orderDtlBo.orderType == 0
                                              ? "普通订单"
                                              : order.orderDtlBo.orderType == 2
                                              ? "集采订单"
                                              : "普通订单"
                                          )
                                        )
                                      ]),
                                      order.firstOrderFlag
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-shrink f14 mar10-l text-center radius10 self-center white first-order-flag"
                                            },
                                            [_vm._v("新客首单")]
                                          )
                                        : _vm._e(),
                                      _vm._m(1, true),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "pad5-l",
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
                                          }
                                        },
                                        [_vm._v("联系客服")]
                                      ),
                                      _c("div", { staticClass: "flex-auto" }),
                                      order.orderDtlBo.orderType == 3 ||
                                      order.orderDtlBo.orderType == 4
                                        ? _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "behalfPurchaseOrderSeller radius4 pad5-lr mar10-lr"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      order.orderDtlBo
                                                        .orderType == 3
                                                        ? "代采订单"
                                                        : "预订单"
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "d_print pad15-r" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                href:
                                                  _vm.env.VUE_APP_APP +
                                                  "mj/order/manage/toOrderPrintdetails?orderId=" +
                                                  order.orderId
                                              }
                                            },
                                            [_vm._v("打印")]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          : _vm._e(),
                        _vm.isSeller == 0
                          ? [
                              _vm._m(2, true),
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-left gray6 des",
                                    attrs: { colspan: "7" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center nowrap"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(_vm._s(order.orderTime))
                                        ]),
                                        _c("div", { staticClass: "pad15-lr" }, [
                                          _vm._v(
                                            "订单编号：" + _vm._s(order.orderId)
                                          )
                                        ]),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              target: "_blank",
                                              href:
                                                _vm.env.VUE_APP_APP +
                                                "shopInfo/shopInfoList.do?shopId=" +
                                                order.shopId
                                            }
                                          },
                                          [_vm._v(_vm._s(order.shopName))]
                                        ),
                                        _vm._m(3, true),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "pad5-l",
                                            attrs: {
                                              target: "_blank",
                                              href:
                                                "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
                                            }
                                          },
                                          [_vm._v("联系客服")]
                                        ),
                                        _c("div", { staticClass: "flex-auto" }),
                                        order.orderDtlBo.orderType == 3 ||
                                        order.orderDtlBo.orderType == 4
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "behalfPurchaseOrder pad10-lr mar10-lr radius4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      order.orderDtlBo
                                                        .orderType == 3
                                                        ? "代采订单"
                                                        : "预订单"
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        order.settlementAmount ||
                                        order.settlementDate
                                          ? _c(
                                              "div",
                                              { staticClass: "pad15-r flex" },
                                              [
                                                order.settlementAmount
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pad10-lr radius5 available-credit"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "可用额度：" +
                                                            _vm._s(
                                                              order.settlementAmount
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                order.settlementDate
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pad10-lr radius5 mar10-l cash-day"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      最后付款日：" +
                                                            _vm._s(
                                                              order.settlementDate
                                                            ) +
                                                            " "
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " （剩" +
                                                              _vm._s(
                                                                order.settlementDay
                                                              ) +
                                                              "天） "
                                                          )
                                                        ]
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          : _vm._e(),
                        _c("tr", [
                          _c("td", {
                            staticClass: "goods",
                            attrs: { colspan: "3" }
                          }),
                          _vm.isSeller == 0
                            ? _c(
                                "td",
                                {
                                  staticClass: "border-l",
                                  staticStyle: { "vertical-align": "middle" },
                                  attrs: { rowspan: "20" }
                                },
                                [
                                  _c("div", { staticClass: "f16" }, [
                                    _vm._v(_vm._s(order.linkman))
                                  ]),
                                  _c("div", { staticClass: "gray6 f12" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(order.tel) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "td",
                            {
                              staticClass: "border-l",
                              staticStyle: { "vertical-align": "middle" },
                              attrs: { rowspan: "20" }
                            },
                            [
                              _c("div", { staticClass: "f16 nowrap red" }, [
                                _vm._v(
                                  "¥ " +
                                    _vm._s(
                                      order.fmoney
                                        ? parseFloat(
                                            order.fmoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    )
                                )
                              ]),
                              _c("div", { staticClass: "gray6 f12" }, [
                                _vm._v(
                                  "（含运费¥ " +
                                    _vm._s(
                                      order.freightMoney
                                        ? parseFloat(
                                            order.freightMoney.toString()
                                          ).toFixed(2)
                                        : "0.00"
                                    ) +
                                    "）"
                                )
                              ])
                            ]
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "border-l",
                              staticStyle: { "vertical-align": "middle" },
                              attrs: { rowspan: "20" }
                            },
                            [
                              _c("div", { staticClass: "gray6 red" }, [
                                _vm._v(_vm._s(order.orderStCn))
                              ]),
                              _vm.isSeller == 0
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        to: "/order/detail/" + order.orderId
                                      }
                                    },
                                    [_vm._v("订单详情")]
                                  )
                                : _vm._e(),
                              _vm.isSeller == 1
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        to:
                                          "/order/detailSeller/" + order.orderId
                                      }
                                    },
                                    [_vm._v("订单详情")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "border-l border-r",
                              staticStyle: { "vertical-align": "middle" },
                              attrs: { rowspan: "20" }
                            },
                            [
                              _vm._l(order.orderButtonEntityList, function(
                                button,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: button.buttonCode },
                                  [
                                    button.isGraySetting == "1"
                                      ? [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: button.buttonMsg,
                                                placement: "top"
                                              }
                                            },
                                            [
                                              index < 2
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      staticClass:
                                                        "w100-min mar5-b is-disabled",
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            button.buttonName
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      : [
                                          index < 2
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "w100-min mar5-b",
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.buttonSubmit(
                                                        button,
                                                        order
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        button.buttonName
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              }),
                              order.orderButtonEntityList.length > 2
                                ? _c(
                                    "el-dropdown",
                                    { attrs: { placement: "bottom-start" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "w100-min mar5-b",
                                          attrs: {
                                            type: "primary",
                                            size: "mini"
                                          }
                                        },
                                        [
                                          _vm._v("更多"),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-arrow-down el-icon--right"
                                          })
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown"
                                        },
                                        [
                                          _vm._l(
                                            order.orderButtonEntityList,
                                            function(button, index) {
                                              return [
                                                index > 1
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        key: button.buttonCode,
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.buttonSubmit(
                                                              button,
                                                              order
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              button.buttonName
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ]),
                        _vm._l(order.orderGoodsBoList, function(orderGoods) {
                          return [
                            _c(
                              "tr",
                              {
                                key: orderGoods.ogId,
                                staticClass: "flex",
                                style: {
                                  width: _vm.isSeller == 1 ? "150%" : "175%"
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "border-l goods flex-auto",
                                    class: {
                                      "border-b":
                                        orderGoods.orderGoodsGiftBo.length > 0
                                    },
                                    staticStyle: { "margin-top": "0px" }
                                  },
                                  [
                                    _c("div", { staticClass: "flex item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "pic flex-shrink" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                href:
                                                  _vm.env.VUE_APP_APP +
                                                  "goods/queryGoodsDetailInfo/" +
                                                  orderGoods.goodsId
                                              }
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    orderGoods.goodsPic +
                                                    "?imageView2/1/w/72/h/72"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-left flex-auto flex flex-column justify-between"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "ellipsis_two" },
                                            [
                                              orderGoods.optimizationCard == 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "mar5-r",
                                                      attrs: {
                                                        type: "danger",
                                                        size: "mini"
                                                      }
                                                    },
                                                    [_vm._v("优选")]
                                                  )
                                                : _vm._e(),
                                              orderGoods.cfyCard == 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "mar5-r",
                                                      attrs: {
                                                        type: "danger",
                                                        size: "mini"
                                                      }
                                                    },
                                                    [_vm._v("处方药")]
                                                  )
                                                : _vm._e(),
                                              orderGoods.preventCard == 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      staticClass: "mar5-r",
                                                      attrs: {
                                                        type: "danger",
                                                        size: "mini"
                                                      }
                                                    },
                                                    [_vm._v("防非")]
                                                  )
                                                : _vm._e(),
                                              orderGoods.goodsTagList &&
                                              orderGoods.goodsTagList.length
                                                ? _vm._l(
                                                    orderGoods.goodsTagList,
                                                    function(tag) {
                                                      return _c(
                                                        "el-tag",
                                                        {
                                                          key: tag,
                                                          staticClass: "mar5-r",
                                                          attrs: {
                                                            type: "danger",
                                                            size: "mini"
                                                          }
                                                        },
                                                        [_vm._v(_vm._s(tag))]
                                                      )
                                                    }
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    target: "_blank",
                                                    href:
                                                      _vm.env.VUE_APP_APP +
                                                      "goods/queryGoodsDetailInfo/" +
                                                      orderGoods.goodsId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(orderGoods.goodsName)
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "gray9 mar5-t" },
                                            [
                                              _vm._v(
                                                _vm._s(orderGoods.goodsSpec)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "flex flex-shrink items-center justify-center",
                                    style: {
                                      width: _vm.isSeller == 1 ? "8%" : "20%"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "x " + _vm._s(orderGoods.goodsQuantity)
                                    )
                                  ]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "flex flex-column flex-shrink items-center justify-center",
                                    style: {
                                      width: _vm.isSeller == 1 ? "22%" : "25%"
                                    }
                                  },
                                  [
                                    orderGoods.sellPrice
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "line-through f12 gray-b"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  ¥\n                  " +
                                                _vm._s(
                                                  orderGoods.sellPrice
                                                    .toString()
                                                    .split(".")[0] +
                                                    "." +
                                                    (orderGoods.sellPrice
                                                      .toString()
                                                      .split(".").length > 1
                                                      ? orderGoods.sellPrice
                                                          .toString()
                                                          .split(".")[1]
                                                      : "00")
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("div", [
                                      _vm._v(
                                        "\n                  ¥\n                  " +
                                          _vm._s(
                                            orderGoods.sellFactPrice
                                              .toString()
                                              .split(".")[0] +
                                              "." +
                                              (orderGoods.sellFactPrice
                                                .toString()
                                                .split(".").length > 1
                                                ? orderGoods.sellFactPrice
                                                    .toString()
                                                    .split(".")[1]
                                                : "00")
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            orderGoods.orderGoodsGiftBo.length > 0
                              ? _vm._l(orderGoods.orderGoodsGiftBo, function(
                                  goodsGift,
                                  index
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key: goodsGift.id,
                                      staticClass: "border-b"
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "border-l goods" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex item" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "pic flex-shrink"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src:
                                                        goodsGift.giftGoodsPicUrl +
                                                        "?imageView2/1/w/72/h/72"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-left flex-auto"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ellipsis_two"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            goodsGift.giftGoodsName
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "gray9 mar5-t"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          goodsGift.giftGoodsSpec
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        { class: { "border-t": !index } },
                                        [
                                          _vm._v(
                                            "\n                  x " +
                                              _vm._s(goodsGift.giftQuantity) +
                                              "\n                  "
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex text-center justify-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "gift" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      goodsGift.promotionDtlId &&
                                                        goodsGift.promotionDtlId !=
                                                          "0"
                                                        ? "赠品"
                                                        : "套餐"
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c("td", {
                                        class: { "border-t": !index }
                                      })
                                    ]
                                  )
                                })
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  })
                : !_vm.loading
                ? _c("tbody", { staticClass: "text-center" }, [_vm._m(4)])
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm.list && _vm.list.length
        ? _c(
            "div",
            { staticClass: "flex justify-end mar20-t" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next",
                  "current-page": _vm.pageNum,
                  total: _vm.totalNum
                },
                on: {
                  "current-change": _vm.currentChange,
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td", { staticClass: "h16", attrs: { colspan: "6" } })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "mar20-l relative",
        staticStyle: { top: "-1px" },
        attrs: {
          target: "_blank",
          href: "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
        }
      },
      [
        _c("img", {
          attrs: {
            src:
              "https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [_c("td", { staticClass: "h16", attrs: { colspan: "7" } })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "mar15-l relative",
        staticStyle: { top: "-1px" },
        attrs: {
          target: "_blank",
          href: "https://work.weixin.qq.com/kfid/kfcd200d8c554673e56"
        }
      },
      [
        _c("img", {
          attrs: {
            src:
              "https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "6" } }, [_vm._v("暂无数据")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }